export enum TransitStatusEnum {
    NewOrganizationWantsToTransitEmployee = "NewOrganizationWantsToTransitEmployee",
    OldOrganizationDeclinedTransition = "OldOrganizationDeclinedTransition",
    EmployeeSuccessfulTransitioned = "EmployeeSuccessfulTransitioned",
    NewOrganizationCancelledTransition = "NewOrganizationCancelledTransition"
}